export const isLocalhost = window.location.hostname === 'localhost';

export const stageEnvironment = {
  isLocal: isLocalhost && import.meta.env.VITE_STAGE === 'dev',
  isDev: import.meta.env.VITE_STAGE === 'dev',
  isSandbox: import.meta.env.VITE_STAGE === 'sandbox',
  isQA: import.meta.env.VITE_STAGE === 'qa',
  isLoad: import.meta.env.VITE_STAGE === 'load',
  isStaging: import.meta.env.VITE_STAGE === 'staging',
  isProd: import.meta.env.VITE_STAGE === 'prod' || import.meta.env.VITE_STAGE === 'production',
};

export const getCreateProjectUrl = () => {
  return import.meta.env.VITE_PUBLIC_URL || '';
};

export function getBaseAdminURL(): string {
  if (stageEnvironment.isLocal) {
    return 'http://localhost:3000';
  }
  if (stageEnvironment.isDev) {
    return `https://admin.brandlive-dev.com`;
  }
  if (stageEnvironment.isQA) {
    return `https://admin.brandlive-qa.com`;
  }
  if (stageEnvironment.isSandbox) {
    return `https://admin.brandlive-sandbox.com`;
  }
  if (stageEnvironment.isStaging) {
    return `https://admin.brandlive-staging.com`;
  }
  if (stageEnvironment.isProd) {
    return 'https://admin.brandlive.com';
  }

  return '';
}
